import * as React from "react";
import styled, { css } from "styled-components";
import { darken } from "polished";

import { Text } from "src/library/components/Text/Text";
import Icon from "src/library/components/Icon/Icon";
import { IAction } from "src/library/components/Button/ActionButton";
import { Button } from "src/library/components/Button";
import { Icons } from "src/library/components/Icon/types";

interface WidgetContainerProps {
  title: string;
  action?: IAction;
}

const WidgetContainer: React.ReactFCWithChildren<WidgetContainerProps> = ({
  children, title, action
}) => {
  return (
    <WidgetContainerWrapper className="hide-scroll">
      <div className="widget-header">
        <div className="widget-drag">
          <Icon
            icon={Icons.DRAG}
            size={20}
            $fillColor="midGrey"
          />
        </div>

        <Text as="h2">
          {title}
        </Text>
      </div>

      <div className={`widget-inner ${action ? "has-action" : "no-action"}`}>
        {children}
      </div>

      {action && (
        <div className="button-container">
          <Button
            onClick={() => action.action()}
            disabled={action.disabled}
            newTabPath={action.newTabPath}
            $buttonType="plain"
          >
            {action.title}
          </Button>
        </div>
      )}
    </WidgetContainerWrapper>
  );
};

export default WidgetContainer;

const WidgetContainerWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    overflow: hidden;
    height: 100%;
    width: 100%;
    border: 2px solid ${theme.colors.lightGrey};
    border-radius: ${theme.borderRadius};
    position: relative;
    overflow-y: scroll;

    &.hide-scroll::-webkit-scrollbar {
      display: none;
    }
    
    &.hide-scroll {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .widget-inner {
      padding: ${theme.spacing.padding.sm};
      height: calc(100% - 50px);

      &.has-action {
        height: calc(100% - 100px);
      }
    }

    .button-container {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background: ${theme.colors.white};
      border-top: 2px solid ${theme.colors.lightGrey};
      
      .button {
        height: 50px;
        width: 100%;

        &:hover {
          opacity: 0.5;
        }
      }
    }

    

    .widget-header {
      padding: ${theme.spacing.padding.sm};
      display: flex;
      width: 100%;
      flex-direction: row;
      align-items: center;
      background: ${darken(0.05, theme.colors.lightestGrey)};

      h2 {
        margin-bottom: 0;
      }
      
      .widget-drag {
        border-right: 1px solid ${theme.colors.midGrey};
        padding-right: ${theme.spacing.padding.sm};
        margin-right: ${theme.spacing.padding.sm};
        
        &:hover {
          cursor: grab;
        }
      }
    }
  `}
`;
